import {Box, Container} from '@mui/material';
import leafIcon from '../../assets/images/LeafIcon.svg';
import LoginFormOTP from '../../components/LoginFormOTP';


const LogInUser = () => {

    return (
    <Container>
        <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" sx={{height:{xs:"calc(100vh - 88px)", sm:"calc(100vh - 96px)"}}}>
            <img src={leafIcon} className='leafIcon' alt='LOGO_KNOW2GROW'/>
            <LoginFormOTP/>
        </Box>
    </Container>
    )
}

export default LogInUser